/**
 * A pod speaker's on-screen label, without parentheses (#765 bug 8,
 * 2026-09-23): "No parentheses in the course — ever." The speaker strings
 * themselves ("Neighbour (8 am)") are DATA and stay untouched — they key the
 * pod's voice cast in listening_pods.speakers, and one pod text per target
 * language stays byte-identical across courses. Only the label is reshaped:
 * "Neighbour (8 am)" → "Neighbour · 8 am".
 */
export function podSpeakerLabel(speaker: string | null | undefined): string {
  return (speaker || '')
    .replace(/\s*\(\s*([^()]*?)\s*\)/g, (_m, inner: string) => (inner ? ` · ${inner}` : ''))
    .replace(/[()]/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim()
}
